import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col cursor-default relative h-screen" }
const _hoisted_2 = { class: "w-full" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "w-full flex justify-center relative" }, [
  /*#__PURE__*/_createElementVNode("div", null, "Trackings")
], -1 /* HOISTED */)
const _hoisted_4 = { class: "w-full flex justify-left items-center relative" }
const _hoisted_5 = {
  key: 0,
  class: "w-full"
}
const _hoisted_6 = {
  key: 0,
  class: "w-full flex flex-row m-4"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "ml-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Table Content "),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          id: "wardtable-filter-text-box",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.trackingTableFilterText) = $event)),
          type: "text",
          placeholder: "Filter...",
          class: "border-2",
          onInput: $setup.onTableSearchTextChanged
        }, null, 544 /* HYDRATE_EVENTS, NEED_PATCH */), [
          [_vModelText, $setup.trackingTableFilterText]
        ])
      ]),
      ($setup.rowData.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode($setup["AgGridVue"], {
              modelValue: $setup.rowData,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.rowData) = $event)),
              style: {"width":"100%","height":"75vh"},
              class: "ag-theme-alpine",
              "grid-options": $setup.gridOptions,
              "default-col-def": {
            sortable: true,
            enableRowGroup: true,
            enableValue: true,
          },
              "row-selection": 'single',
              onCellClicked: $setup.cellClicked,
              onFirstDataRendered: $setup.dataReady
            }, null, 8 /* PROPS */, ["modelValue"]),
            ($setup.selectedTracking)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  ($setup.selectedTracking.audioFile)
                    ? (_openBlock(), _createElementBlock("audio", {
                        key: 0,
                        controls: "",
                        src: `${$setup.baseUrl}/api/audio/file?audioref=${$setup.selectedTracking.oid}`
                      }, null, 8 /* PROPS */, _hoisted_7))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("p", _hoisted_8, "Results: " + _toDisplayString($setup.selectedTracking?.details.results), 1 /* TEXT */)
                ]))
              : _createCommentVNode("v-if", true)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}